import React from "react";
import { ErrorBoundary } from "traec-react/errors";
import Octicon from "react-octicon";

export default function ReportRowErrorBoundary(props) {
  let msg = props.msg || (
    <td colSpan="100%" className="border-0">
      <span>Error loading report row</span>
    </td>
  );
  return (
    <ErrorBoundary title={null} ContainerTag="tr" className="alert alert-warning m-0 p-0 border-0" msg={msg}>
      {props.children}
    </ErrorBoundary>
  );
}

export function MiniErrorBoundary(props) {
  return (
    <ErrorBoundary title={null} ContainerTag="span" className="badge badge-warning" msg={<Octicon name="bug" />}>
      {props.children}
    </ErrorBoundary>
  );
}

export function CellSpanErrorBoundary(props) {
  let msg = props.msg || (
    <td colSpan={props.colSpan} className="border-0">
      <span>Error loading cells</span>
    </td>
  );
  return (
    <ErrorBoundary title={null} ContainerTag="td" className="badge badge-warning border-0" msg={msg}>
      {props.children}
    </ErrorBoundary>
  );
}
